(function(){
  'use strict';
  var THRESHOLD = 1000;
  var isLoading = false;
  var mutObs = null;

  function getBtn() {
    return document.querySelector('a.loadMore, button.loadMore');
  }

  function tryLoad() {
    if (isLoading) return;
    var scrollBottom = window.scrollY + window.innerHeight;
    var pageHeight = document.body.scrollHeight;
    if (scrollBottom < pageHeight - THRESHOLD) return;

    var btn = getBtn();
    if (!btn) return;

    isLoading = true;
    btn.click();
  }

  function watchForNewProducts() {
    var w = document.querySelector('.fl1.w_100.main-col') ||
             document.querySelector('#Collection') ||
             document.querySelector('#PageContainer') ||
             document.querySelector('main');
    if (!w || mutObs) return;

    mutObs = new MutationObserver(function() {
      if (isLoading && getBtn()) {
        isLoading = false;
        setTimeout(tryLoad, 100);
      }
    });
    mutObs.observe(w, { childList: true, subtree: true });
  }

  function init() {
    if (!getBtn()) return;
    window.addEventListener('scroll', tryLoad, { passive: true });
    watchForNewProducts();
    setTimeout(tryLoad, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();